import type {SelectionCondition} from '@dms/api/new-vehicle';

/**
 * Mirrors the backend `SelectionCondition::isSatisfiedBy`: the variant is one of `anyOfVariantIds`
 * (an empty list means any variant) and every `allOfFeatureIds` id is in the build.
 */
export const isSelectionConditionMet = (
  condition: SelectionCondition,
  variantId: string,
  featureIds: readonly string[]
) =>
  (condition.anyOfVariantIds.length === 0 || condition.anyOfVariantIds.includes(variantId)) &&
  condition.allOfFeatureIds.every((id) => featureIds.includes(id));
